import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

export interface Props {
  className?: string;
  children: any;
}

class PageWrapper extends React.Component<Props, any> {
  render() {
    const { children, className } = this.props;

    return <div className={className}>{children}</div>;
  }
}

const Styled = styled(PageWrapper)`
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: column nowrap;
`;

export default Styled;
